/* eslint-disable react/react-in-jsx-scope */
import PropTypes from 'prop-types'
import iconName from '../../helper/constant/iconName'
import icons from '../../helper/icons'

const PermissionShow = ({ Img = '', Text = '' }) => {
  const image = icons(Img || iconName.accessDenied, process.env.REACT_APP_BRAND_NAME)
  const text = Text || 'You do not have access to this page'
  return (
    <>
      <div className="content-wrapper d-flex flex-column justify-content-center align-items-center container-access-denied mt-5">
        <img alt="Access Denied" src={image} width="50%" height="50%" />
        <h3>{text}</h3>
      </div>
    </>
  )
}

PermissionShow.propTypes = {
  Img: PropTypes.string,
  Text: PropTypes.string,
}

PermissionShow.defaultProps = {
  Img: '',
  Text: '',
}

export default PermissionShow
